import React from 'react';
import { Link } from 'react-router-dom';
import homeIcon from '../images/homeIcon.png';
import browseIcon from '../images/browseIcon.png';
import createIcon from '../images/createIcon.png';
import profileIcon from '../images/profileIcon.png';
import logo from '../images/logo.png';
import { secondaryColor } from '../utils/DisplaySettings';
import { Nav, Image } from 'react-bootstrap';

function Navigation() {
    const renderLink = (path, label, icon) => (
        <Link 
            to={path} 
            className="d-flex flex-column flex-md-row align-items-center text-white text-decoration-none"
            style={{ 
                transition: 'box-shadow 0.3s',
                whiteSpace: 'nowrap',
                padding: '0.25rem',
                flex: '1 1 0',
                minWidth: 0
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = `0 0 0.8rem rgba(254, 68, 98, 1.0)`}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
        >
            <Image 
                src={icon} 
                alt={`${label} icon`} 
                className="mb-1 mb-md-0 me-md-2"
                style={{ 
                    width: 'clamp(2rem, 3.5vw, 3.5rem)',
                    aspectRatio: '1/1'
                }}
            />
            <span className="text-center text-md-start" style={{ flex: '0 1 auto', fontSize: '0.5rem' }}>{label}</span>
        </Link>
    );

    return (
        <>
            <Nav 
                className="d-flex flex-row align-items-center bg-black fixed-top w-100 py-2"
                style={{
                    zIndex: 1000,
                    borderBottom: '0.125rem solid',
                    borderColor: secondaryColor,
                    boxShadow: `0 0.125rem 0.9375rem ${secondaryColor}, 0 0 0.625rem ${secondaryColor}`,
                    minHeight: 'clamp(5rem, 7vw, 8rem)'
                }}
            >
                <Image 
                    src={logo} 
                    alt="Logo" 
                    className="d-none d-lg-block me-lg-3"
                    style={{ width: 'clamp(8rem, 10vw, 12rem)' }}
                />
                
                <div className="d-flex flex-row align-items-center w-100 w-md-auto justify-content-between px-2 px-md-4 gap-2" style={{
                    maxWidth: '32rem'
                }}>
                    {renderLink("/", "Home", homeIcon)}
                    {renderLink("/attend", "Attend", browseIcon)}
                    {renderLink("/create", "Create", createIcon)}
                    {renderLink("/profile", "Profile", profileIcon)}
                </div>
            </Nav>
            <div style={{ height: 'clamp(6rem, 8vw, 9rem)' }}></div>
        </>
    );
}

export default Navigation;